import { RefundModel } from 'api-hooks/refund/refund';
import Separator from 'components/common/separator';
import Text from 'components/elements/text';
import { CardSection, FullContainer } from 'legacy-modules/styles';
import useTranslation from 'next-translate/useTranslation';
import { useFieldArray, useFormContext } from 'react-hook-form';

import AddonsDocumentTable from './addons-document';
import GuestDetailTable from './guest-detail';

interface Props {
  refund?: RefundModel;
}

export default function DocumentSaleSection(props: Props) {
  const { control } = useFormContext();
  const name = 'documentSales';
  const { fields } = useFieldArray({
    control,
    name,
    keyName: 'customId',
  });

  const { t } = useTranslation();

  if (fields.length === 0) {
    return null;
  }
  return (
    <>
      {fields.map((field, index) => {
        return (
          <>
            <Separator gap={24} />
            <CardSection key={field.customId}>
              <FullContainer>
                <Text variant="HeadingXSmall">
                  {t('document:document_details')} {index + 1}
                </Text>
                <GuestDetailTable
                  type={(field as any).documentType}
                  parentIndex={index}
                  refund={props.refund}
                />

                <AddonsDocumentTable
                  parentIndex={index}
                  refund={props.refund}
                />
              </FullContainer>
            </CardSection>
          </>
        );
      })}
    </>
  );
}
